module.exports = __webpack_public_path__ + "img/send-invites-desktop-ru.a51b3dde.jpg";